export default {
  REQUIRED_FIELD: 'Ce champ est obligatoire',
  INVALID_MAIL: 'Email invalide',
  INVALID_PHONE: 'Téléphone invalide',
};
